import AsyncSelect from 'Shared/components/AsyncSelect'

export default function SubfilterAsyncSelect({
  id, name, fields, onChange
}) {
  const { parameters } = useSel((s) => s.rules.entities[id])
  const value = parameters[name]
  const { endpoint, parentEntityIdTitle, notValidText, dependsOn, loadStaticList } = fields[name]

  const entityId = parameters?.[_.camelCase(parentEntityIdTitle)]
  const endpointWithEntityId = '/api/' + endpoint.replace(`{${parentEntityIdTitle}}`, entityId || '')

  if (!entityId) {
    return <p>{notValidText}</p>
  }

  return (
    <AsyncSelect
      value={value}
      baseEndpoint={endpointWithEntityId}
      onChange={onChange}
      loadStaticList={(dependsOn || []).length > 0 && loadStaticList}
    />
  )
}
